/*======= Include App Css and Js Files =======*/

//Algolia css
import 'instantsearch.css/themes/algolia.css';

//credit card component
import 'react-credit-cards/es/styles-compiled.css';

// Custom Style File
import '../assets/scss/_style.scss';


// WEBPACK FOOTER //
// ./src/lib/embryoCss.js